
















































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import DepartmentInfo from './Service/DepartmentInfo';
import searchForm from './form';

@Component
export default class componentName extends Vue {
  private searchForm: {} = searchForm;

  private form: any = {};

  private DepartmentInfo: Array<Object> = [];

  /** 取得列表 */
  public async getDepartmentInfo(params?: object) {
    const getter = (await new DepartmentInfo().get()) as any;
    this.DepartmentInfo = getter;
  }

  private advSearch() {
    this.form.page = 1;
    const query: any = { ...this.$route.query, ...this.form };
    delete query.search_complex;
    this.$emit('close');
    this.$router.push({ query });
  }

  private resetForm(formName: string) {
    this.form = {};
    const { path } = this.$route;
    this.$emit('close');
    this.$router.push(path);
  }

  private mounted() {
    this.getDepartmentInfo();

    const { query } = this.$route;
    const querySetting = JSON.parse(JSON.stringify(query));
    this.form = querySetting;
  }
}
